import React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';
import {
  SpanElement,
  type HeadingFourElement,
} from '~/components/organism/PluginsEditor/types';
import ELEMENTS from '~/components/organism/PluginsEditor/components/elements/elementsEnum';
import serializeHeading from '../../../utils/serialize/serializeHeading';

export type Props = RenderElementProps & {
  element: SpanElement;
};

const HeadingFour: React.FCC<Props> = ({ attributes, element, children }) => (
  <Container {...attributes} {...element.attributes}>
    {children}
  </Container>
);

const Container = styled.h4<{}>`
  margin: 0;
`;

export default {
  renderComponent: props => <HeadingFour {...props} />,
  nodeName: 'H4',
  deserialize: () => ({
    type: ELEMENTS.H4,
  }),
  serialize: (node: HeadingFourElement, children) =>
    serializeHeading('h4', children),
};
